<ng-container>
    <p-tabs class="no-padding" value="medicalProcedures">
        <p-tablist>
            <p-tab value="medicalProcedures">{{ 'voucher.prescriptions.tabs.medicalProcedures' | translate }}</p-tab>
            <!-- TODO: app-voucher-detail-prescriptions-visits -->
            <!-- TODO: app-voucher-detail-prescriptions-absence -->
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel value="medicalProcedures">
                <app-voucher-detail-prescriptions-medical-procedures></app-voucher-detail-prescriptions-medical-procedures>
            </p-tabpanel>
            <!-- TODO: app-voucher-detail-prescriptions-visits -->
            <!-- TODO: app-voucher-detail-prescriptions-absence -->
        </p-tabpanels>
    </p-tabs>
</ng-container>
